module.exports = __webpack_public_path__ + "img/mainleft.676c4c39.png";